import { Flex, styled } from '@grupoboticario/flora-react';

const styles = {
  SectionWrapper: styled(Flex, {
    background: '$light-dark-1',
    padding: '$6 0 $12',
    minHeight: 'calc($20 * 4)',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  }),
};

export default styles;
